export type ImageBypassRule = {
  host?: string;
  pathPrefix?: string;
  protocol?: 'http' | 'https';
};

/**
 * True when an absolute image URL matches one of the bypass rules and should
 * therefore skip the host's image optimizer (rendered `unoptimized`). Non-string
 * and relative sources never bypass. Rules are supplied by the host app so this
 * stays domain-agnostic.
 */
export function shouldBypassImageOptimization(src: unknown, rules: ImageBypassRule[]): boolean {
  if (typeof src !== 'string') return false;
  if (!/^(https?:)?\/\//i.test(src)) return false;
  try {
    const url = new URL(src, 'http://dummy');
    return rules.some((rule) => {
      const hostOk = !rule.host || url.hostname === rule.host;
      if (!hostOk) return false;
      const protoOk = !rule.protocol || url.protocol.replace(':', '') === rule.protocol;
      if (!protoOk) return false;
      const pathOk = !rule.pathPrefix || url.pathname.startsWith(rule.pathPrefix);
      return pathOk;
    });
  } catch {
    return false;
  }
}
